<app-header-component
  [headerData]="currentHeaderData"
  (closeModal)="closeModal()"
></app-header-component>

<ion-toolbar>
  <ion-searchbar
    #countrySearch
    mode="ios"
    placeholder="{{
      'hotel.select_country_modal.search_nationality' | translate
    }}"
    (keyup.enter)="filterListOnEnter($event)"
    (ionInput)="filterLIst($event)"
    (ionClear)="initPageState()"
  >
  </ion-searchbar>
</ion-toolbar>

<ion-content>
  <ion-grid *ngIf="noData; else showList" class="ion-text-center v-center">
    <ion-row>
      <ion-col size="12">
        <ion-label class="fs-3 font500 text-color">{{
          "hotel.select_country_modal.no_data" | translate
        }}</ion-label>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ng-template #showList>
    <div *ngIf="suggestionList.length > 0">
      <ion-list class="ion-padding-end ion-list-transparent-bg-color">
        <ion-item
          *ngFor="let item of suggestionList"
          class="ion-label-transparent-bg-color"
          (click)="selectSuggestion(item)"
        >
          <ion-note class="emoji" slot="start">{{ item.emoji }}</ion-note>
          <ion-label>
            <p class="fs-3 font500 airport_name paragraph-primary-text-color">
              {{ item.nationality }}
            </p>
          </ion-label>
        </ion-item>
      </ion-list>
      <ion-infinite-scroll
        [disabled]="lastPage"
        (ionInfinite)="getNextPage($event)"
      >
        <ion-infinite-scroll-content loadingSpinner="crescent">
        </ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </div>

    <div *ngIf="suggestionList.length <= 0 && loading">
      <ion-list>
        <ion-item *ngFor="let item of [0, 1, 2, 3, 4, 5, 6, 7]">
          <ion-label>
            <h3>
              <ion-skeleton-text animated style="width: 80%; height: 16px">
              </ion-skeleton-text>
            </h3>
            <p>
              <ion-skeleton-text animated style="width: 50%">
              </ion-skeleton-text>
            </p>
          </ion-label>
        </ion-item>
      </ion-list>
    </div>
  </ng-template>
</ion-content>
